export const ActiveCampaignIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M13.2834 9.96984L5.45069 15.1715C5.08781 15.4134 4.90625 15.8064 4.90625 16.1996V17.5L14.4023 11.2702C14.8257 10.9678 15.0979 10.4839 15.0979 9.96984C15.0979 9.4557 14.856 8.97174 14.4023 8.66934L4.90625 2.5V3.70963C4.90625 4.13311 5.11799 4.52617 5.45069 4.73791L13.2834 9.96984Z"
        fill="#004CFF"
      />
      <path
        d="M8.56558 10.3941C8.98894 10.6662 9.53338 10.6662 9.95674 10.3941L10.622 9.94047L5.66231 6.58366C5.35991 6.37192 4.90625 6.58366 4.90625 6.97672V7.9747L7.47682 9.69855L8.56558 10.3941Z"
        fill="#004CFF"
      />
    </svg>
  );
};
